import { makeUseAxios } from "axios-hooks";

import { Config } from "@/utils/config.utils";

import { createApiFor, ExtendedUseAxios } from "./utils";

const bffRecommendServiceAxiosInstance = createApiFor(
    `/${Config.general.basestore}`,
    {
        bff: true
    }
);

const useBFFRecommendServiceApi = makeUseAxios({
    axios: bffRecommendServiceAxiosInstance,
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

export { useBFFRecommendServiceApi };
